import React from 'react';
import { IProps, IState } from './types';
import { Program } from 'bff/models/product';
import Activity from 'components/Home/Activity';
import FlowRemind from 'components/Home/FlowRemind';
import InsureRules from 'components/Home/InsureRules';
import MainVisual from 'components/Home/MainVisual';
import ProdFeature from 'components/Home/ProdFeature';
import ProdKind02 from 'components/Home/ProdKind02';
import Service from 'components/Home/Service';
import { CodeId } from 'constants/enums/codeId.enum';
import { InsType as InsTypeEnum } from 'constants/enums/insType.enum';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import _ from 'lodash';
import commonService from 'utils/commonService';
import service from './apis/petInsHomeService';
import Instruction from './Instruction';
import PlansTable from './PlansTable';
import ClaimsFlow from './ClaimsFlow';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

class PetIns extends React.Component<IProps, IState> {
  private sectionProdKindRef = React.createRef() as React.RefObject<HTMLDivElement>;

  readonly state: IState = {
    inscat: {
      BRIEF: '',
      NOTE: '',
      INS_TYPE_NAME: '',
      INS_TYPE_ID: '',
      IMAGE_LEFT_MOBILE: '',
      IMAGE_LEFT_PC: '',
      INS_TYPE_HOME_URL: '',
      SN: 0,
      IMAGE_RIGHT_PC: '',
      IMAGE_RIGHT_MOBILE: ''
    },
    programs: [],
    products: [],
    features: [],
    flows: [],
    activities: {
      ACTIVITY: [],
      MORE_ACTIVITY_URL: ''
    },
    serviceLinks: [],
    creditCardCode: [],
    bulletin: {
      BULLETIN: {}
    },
    UICode: [],
    petRecommands: {},
    programId: ''
  }

  async componentDidMount () {
    commonService.scrollToTop();

    const initSettingRes = await service.fetchInitSetting('');

    this.setState({
      inscat: { ...initSettingRes.inscat },
      programs: [...initSettingRes.programs],
      products: [...initSettingRes.products],
      features: [...initSettingRes.features],
      flows: [...initSettingRes.flows],
      activities: { ...initSettingRes.activities },
      serviceLinks: [...initSettingRes.serviceLinks],
      creditCardCode: [...initSettingRes.creditCardCode],
      bulletin: { ...initSettingRes.bulletin },
      petRecommands: { ...initSettingRes.petRecommands },
      UICode: [...initSettingRes.UICode]
    });
  }

  componentDidUpdate (preProps: IProps, preState: IState) {
    this.handleShowBulletin(preState);
  }

  /**
   * @description 公告彈窗
   */
  handleShowBulletin = (preState: IState) => {
    const showAnnounce = Object.keys(preState.bulletin.BULLETIN).length !== Object.keys(this.state.bulletin.BULLETIN).length && this.state?.bulletin?.BULLETIN.END_TIME;

    if (showAnnounce && !storageService.getItem(storageKeys.PetInsAnnounceChecked)) {
      commonService.showAnnounceModal(
        this.state.bulletin.BULLETIN.END_TIME || '', this.state.bulletin.BULLETIN.TITLE, this.state.bulletin.BULLETIN.CONTENT
      );
      storageService.setItem(storageKeys.PetInsAnnounceChecked, 'checked');
    }
  }

  /**
   * @description 「主視覺」區塊點擊 SCROLL 按鈕，視窗滾動商品種類
   */
  handleMainVisualScrollToNextSection = () => {
    const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
    if (this.sectionProdKindRef && this.sectionProdKindRef.current) {
      window.scrollTo({ top: this.sectionProdKindRef.current.offsetTop - headerHeight, behavior: 'smooth' });
    }
  }

  render () {
    let mainVisual;
    if (this.state.inscat.INS_TYPE_ID) {
      const backgroundImages = [
        {
          theme: InsTypeDefinesEN[InsTypeEnum.Pet],
          pcLeftImgPath: this.state.inscat.IMAGE_LEFT_PC,
          pcRightImgPath: this.state.inscat.IMAGE_RIGHT_PC,
          mobileImgPath: this.state.inscat.IMAGE_LEFT_MOBILE
        }
      ];

      let newsAds;
      if (this.state.programs.length > 0) {
        newsAds = _.map(this.state.programs, (program: Program) => ({
          title: program.PROGRAM_NAME,
          content: program.NOTE
        }));
      }

      mainVisual = (
        <MainVisual
          title={`旺旺友聯${this.state.inscat.INS_TYPE_NAME}`}
          subTitle={this.state.inscat.BRIEF}
          newsAds={newsAds}
          backgroundImages={backgroundImages}
          scrollDownBtnText="我要試算"
          onScroll={this.handleMainVisualScrollToNextSection}
        />
      );
    }

    let flowRemind;
    if (this.state.flows && this.state.flows.length > 0) {
      const flow = { ...this.state.flows[0] };
      const flowItems = [
        {
          icon: flow.IMAGE_NAME_PC_1,
          text: flow.BRIEF_1,
          title: flow.FLOW_TITLE_1
        },
        {
          icon: flow.IMAGE_NAME_PC_2,
          text: flow.BRIEF_2,
          title: flow.FLOW_TITLE_2
        },
        {
          icon: flow.IMAGE_NAME_PC_3,
          text: flow.BRIEF_3,
          title: flow.FLOW_TITLE_3
        },
        {
          icon: flow.IMAGE_NAME_PC_4,
          text: flow.BRIEF_4,
          title: flow.FLOW_TITLE_4
        }
      ];

      flowRemind = (
        <FlowRemind.Flow
          items={flowItems}
          itemIconStyles={{ marginBottom: '10px' }}
        />
      );
    }

    return (
      <div className="product-travel-ins" id="product-pet-ins">
        {/* 主視覺 */}
        {mainVisual}
        {/* 商品種類 */}
        <ProdKind02
          products={this.state.products}
          recommands={this.state.petRecommands}
          sliderName={InsTypeDefinesEN[InsTypeEnum.Pet]}
          refSetting={this.sectionProdKindRef}
          programId={this.state.programId}
          slidesPerView={3}
        />
        {/* 商品特色 */}
        <ProdFeature isPet features={this.state.features} itemImgStyles={{ width: '77%' }} />

        {/* 投保規則 */}
        <InsureRules styles={{ textAlign: 'center' }} isPet>
          <div className="flow-remind__title" style={{ margin: '0 0 2rem 0' }}>投保方案</div>
          <PlansTable />
          <div className="flow-remind__title" style={{ margin: '2rem 0' }}>投保須知</div>
          <Instruction />
        </InsureRules>

        {/* 投保流程及溫馨提醒 */}
        <FlowRemind title="投保流程及溫馨提醒">
          {flowRemind}
          <div style={{ textAlign: 'center', marginTop: '7rem' }}>
            <div className="flow-remind__title">理賠流程</div>
          </div>
          <ClaimsFlow />
          <div className="flow-remind__title" style={{ textAlign: 'center', marginTop: '7rem' }}>注意事項</div>
          <FlowRemind.Remind>
            <p>◆ <span style={{ color: 'red' }}>內視鏡手術、導尿手術、細針採樣、電腦斷層掃描..等，若無切開或切除等行為，無法申請手術費用，另口腔疾病、白內障、治療短吻呼吸道症候群所生之費用等不予理賠。</span></p>
            <p>◆ 依據旺旺友聯產物寵物全能綜合保險條款第21條第4款之規定，凡保險契約生效前已存在且尚未痊癒疾病或傷害，或續約後所生原保險契約保險期間內尚未痊癒疾病或傷害，其所生醫療費用，旺旺友聯產險公司不負賠償之責。</p>
            <p>◆ 被保險寵物因疾病或傷害所致保險事故發生，其診療行為僅限於診療當下登載於旺旺友聯產險公司官方網頁之指定獸醫院進行，否則旺旺友聯產險公司不負賠償之責，但經指定獸醫院視需要開立轉診單者，不在此限。</p>
            <p>◆ 本商品並非保證續保，<span style={{ color: 'red' }}>隔年度將依據實際理賠狀況決定是否得以續保。</span></p>
            {/* <div
              style={{
                width: '80%',
                margin: '1rem auto'
              }}
            >
              <table
                className="remind-table"
                style={{ width: '100%' }}
              >
                <tr>
                  <th colSpan={2} style={{ textAlign: 'center' }}>無賠款減費</th>
                  <th colSpan={2} style={{ textAlign: 'center' }}>賠款加費</th>
                </tr>
                <tr>
                  <th>無賠款年度</th>
                  <th>減費標準</th>
                  <th>前一年度賠款次數</th>
                  <th>加費標準</th>
                </tr>
                <tr>
                  <th>前1年度</th>
                  <th>減費20%</th>
                  <th>2次以下</th>
                  <th>無加費</th>
                </tr>
                <tr>
                  <th>連續2年</th>
                  <th>減費30%</th>
                  <th>3次</th>
                  <th>加費30%</th>
                </tr>
                <tr>
                  <th>連續3年或以上</th>
                  <th>減費40%</th>
                  <th>4次</th>
                  <th>加費50%</th>
                </tr>
                <tr>
                  <th> </th>
                  <th> </th>
                  <th>超過4次</th>
                  <th>每增加1次，加費10%</th>
                </tr>
              </table>
              <p>註1：加減費僅限「寵物醫療費用保險」此承保項目，且賠款次數以保險事故次數為計算基礎。</p>
              <p>註2：前1年度無賠款紀錄者，即以減費標準計算續保保險費，有賠款紀錄則以加費標準計算。</p>
              <p>註3：保險人於保單到期前結算賠款次數，倘於該期間後申請理賠而未結算之賠款次數，則納入下年度計算。</p>
            </div> */}
            <p>◆ 商品名稱：旺旺友聯產物寵物全能綜合保險。</p>
            <p>◆ 商品文號：<span style={{ color: 'red' }}>115.09.01旺總精算字第1150001462號函備查。</span></p>
            <p>◆ 本保險商品悉依保險相關法令辦理，並受有財產保險安定基金之保障。</p>
            <p>◆ 條款內容(承保範圍、不保事項等)詳『商品條款』。</p>
            <p>◆ 消費者於購買前，應詳閱各種銷售文件內容，本商品之預定費用率(預定附加費用率)最高45 %，最低20 %；如要詳細了解其他相關資訊，請洽本公司業務員、服務據點(免付費電話 :0800-024-024 )或網站(網址: www.wwunion.com )，以保障您的權益。</p>
            <p>◆ 資訊公開查詢：http://www.wwunion.com 消費者可至保險公司總、分支機構、網址查閱或索取書面資訊公開說明文件。</p>
            <p>◆ 本公司保留承保與否之權利。其他未盡詳細事項，依保單條款辦理。</p>
          </FlowRemind.Remind>
        </FlowRemind>

        {/* 熱門活動 */}
        <Activity activities={this.state.activities} moreActivityText={commonService.getCodeMsg(this.state.UICode, CodeId.U017)} />
        {/* 常用服務 */}
        <Service serviceLinks={this.state.serviceLinks} isPet />
      </div>
    );
  }
}

export default PetIns;
